import React from "react";
import {
  FormControl,
  FormLabel,
  FormControlLabel,
  Checkbox,
  Switch,
} from "@mui/material";
import { Controller, get, useFormContext } from "react-hook-form";

interface CheckboxFieldRegProps {
  fieldName: string;
  label?: string;
  control?: any;
  error?: boolean;
  helperText?: string | null | undefined;
  defaultValue?: boolean;
  isDisable?: boolean;
  labelColor?: string;
  required?: boolean;
  type?: "checkbox" | "toggle";
}

const CheckboxFieldReg: React.FC<CheckboxFieldRegProps> = ({
  fieldName,
  control,
  label,
  error: errorBool,
  helperText: displayHelperText,
  defaultValue = false,
  isDisable = false,
  labelColor,
  required = false,
  type = "checkbox",
}) => {
  const {
    control: formControl,
    setValue: setField,
    getValues,
    formState: { errors },
  } = useFormContext();

  const ControlComponent = type === "toggle" ? Switch : Checkbox;

  const methods = useFormContext();
  const helperFromErrors = get(errors, fieldName)?.message?.toString();
  const rawError = errorBool ?? !!get(errors, fieldName);

  const fieldState = (methods as any)?.getFieldState
    ? (methods as any).getFieldState(fieldName)
    : null;
  const isTouched = !!(
    (methods?.formState && methods.formState.touchedFields && methods.formState.touchedFields[fieldName]) ||
    fieldState?.isTouched
  );
  const showError = !!rawError && (isTouched || (methods?.formState && methods.formState.isSubmitted));
  const helperText = displayHelperText ?? helperFromErrors;

  return (
    <FormControl>
      {labelColor && (
        <FormLabel sx={{ mt: 1, color: labelColor || "secondary.main" }}>
          {label}
        </FormLabel>
      )}
      <Controller
        name={fieldName}
        control={control ?? formControl}
        defaultValue={defaultValue}
        render={({ field }) => (
          <FormControlLabel
            control={
              <ControlComponent
                {...field}
                checked={field.value}
                onChange={(e) => field.onChange(e.target.checked)}
                disabled={isDisable}
                    color={showError ? "error" : "primary"}
              />
            }
            label={label && `${label}${required ? " *" : ""}`}
          />
        )}
      />
          {showError && helperText && (
            <p style={{ color: "red", margin: 0 }}>{helperText}</p>
          )}
    </FormControl>
  );
};

export default CheckboxFieldReg;
